<link rel="stylesheet" href="https://cache.amap.com/lbs/static/main1119.css"/>

<template>
  <Form class="commonForm" :ref="refName" :model="formModel"
    :style="{'overflow-y':'auto','overflow-x':'hidden'}" :rules="formRules"
     label-position="top">
     <Spin size="large" fix v-if="spinShow"></Spin>
    <Row >
      <!-- <Col span="24">
        <FormItem
          label="上级区域:"
          prop="parent_code">
            <Select v-model="formModel.parent_code" readonly transfer placeholder="请选择上级区域">
              <Option
                v-for="item in codeData"
                :value="item.value"
                :key="item.value">{{ item.label }}</Option>
            </Select>
        </FormItem>
      </Col> -->
      <Col span="24">
        <FormItem
          :label="_vm.$t('agentmenu.agentname')"
          prop="shop_name">
            <Input v-model="formModel.shop_name" :placeholder="_vm.$t('agentmenu.agentnameplaceholer')" />
        </FormItem>
      </Col>
      <!-- <Col span="24">
        <FormItem
          label="应用ID:"
          prop="client_id">
            <Input v-model="formModel.client_id" placeholder="请输入应用ID" />
        </FormItem>
      </Col> -->
      <Col span="24">
        <FormItem
          :label="_vm.$t('agentmenu.contactperson')"
          prop="contacts_name">
            <Input v-model="formModel.contacts_name" :placeholder="_vm.$t('agentmenu.contactpersonplaceholer')" />
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem
        :label="_vm.$t('agentmenu.area')"
          prop="area_code">
            <!-- <Input v-model="formModel.shop_name" placeholder="请输入区域" /> -->
            <Tree v-model="formModel.area_code" :data="areaData" show-checkbox multiple  @on-check-change="onCheckChange"></Tree>

        </FormItem>
      </Col>
      <Col span="24">
        <FormItem
        :label="_vm.$t('agentmenu.address')"
          prop="address">
            <Input disabled v-model="formModel.address" readonly :placeholder="_vm.$t('agentmenu.addressplaceholer')" />
        </FormItem>
      </Col>
      <Col span="24">
            <FormItem :label="_vm.$t('agentmenu.maplnglat')" prop="lng">
              <Input v-model="formModel.lng" style="display:none;" :placeholder="_vm.$t('agentmenu.enterlng')" />
              <Input v-model="formModel.lat" style="display:none;"  :placeholder="_vm.$t('agentmenu.enterlat')" />
              <Input class="inputContent" search enter-button @on-search="searchMap" :placeholder="_vm.$t('agentmenu.entersearchname')" />
              <div id="container1" >
              </div>
            </FormItem>
          </Col>
      <Col span="24">
        <FormItem
          :label="_vm.$t('agentmenu.aftercontact')"
          prop="after_sale_tel">
            <Input v-model="formModel.after_sale_tel" :placeholder="_vm.$t('agentmenu.aftercontactplaceholer')" />
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem
          :label="_vm.$t('agentmenu.loginaccount')"
          prop="contacts_tel">
            <Input v-model="formModel.contacts_tel"   :disabled="edit" :placeholder="_vm.$t('agentmenu.loginaccountplaceholer')" />
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem
        :label="_vm.$t('agentmenu.loginpassword')"
          prop="login_password">
            <Input v-model="formModel.login_password" :placeholder="_vm.$t('agentmenu.loginpasswordplaceholer')" />
        </FormItem>
      </Col>
      <!-- <Col span="24">
        <FormItem
        :label="_vm.$t('agentmenu.paramsconfigpass')"
           >
            <Input v-model="formModel.params_config_password" :placeholder="_vm.$t('agentmenu.paramsconfigpassplaceholer')" />
        </FormItem>
      </Col> -->
   <Col span="24">
                  <FormItem :label="_vm.$t('设置默认角色权限')" prop="group_codes">
                  <Select v-model="formModel.group_codes"  filterable :placeholder="_vm.$t('请选择')" multiple>
                    <Option v-for="(item,i) in roleData" :key="i" :value="item.group_code">  {{ item.is_default === 1 ? `${item.group_name} (默认)` : item.group_name }}</Option>
                  </Select>
                </FormItem>
               </Col>
      <Col span="24">
  <FormItem
          :label="_vm.$t('是否有密码管理权限')"
          prop="pass_priv">
          <RadioGroup v-model="formModel.pass_priv">
              <Radio :label="1">
                  <span>{{_vm.$t('有权限')}}</span>
              </Radio>
              <Radio :label="2">
                  <span>{{_vm.$t('无权限')}}</span>
              </Radio>
          </RadioGroup>
        </FormItem>
          <FormItem
          :label="_vm.$t('是否有参数设置权限')"
          prop="params_priv">
          <RadioGroup v-model="formModel.params_priv">
              <Radio :label="1">
                  <span>{{_vm.$t('有权限')}}</span>
              </Radio>
              <Radio :label="2">
                  <span>{{_vm.$t('无权限')}}</span>
              </Radio>
          </RadioGroup>
        </FormItem>
      </Col>

      <Col span="24">
        <FormItem
          :label="_vm.$t('agentmenu.remark')"
          >
            <Input v-model="formModel.desc" :placeholder="_vm.$t('agentmenu.remarkplaceholer')" />
        </FormItem>
      </Col>

    </Row>

  </Form>
</template>

<script>
import config from '@/config'
import {pests} from '@/api/api_url'
import {getgrouplist} from '@/api/auth'
import {renderFormMixins} from '@/mixins/renderFormMixins'
import {patrolcateGetAllCate,catch_fear_timelist,deviceinfo_list,area_list} from '@/api/jingxiaoshang'
//import commonTitle from '@/view/console/components/commonTitle'

export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data () {
    return {
      zoom:3,
      BMap:null,
      map:null,
      keyword:null,
      location:null,
      areaData:[],
      tableloading:false,
      codeData:[],//数据
 roleData:[],
      path:[],
      reqBase:{},
      formModel: {
        parent_code:"",
        shop_name: null,
       // client_id:null,
        contacts_name: null,
        area_code: null,
        address: null,
        after_sale_tel: null,
        contacts_tel: null,
        login_password: null,
        params_config_password:null,
        desc: null,
        lng:0,
        lat: 0,
        pass_priv:1,
        params_priv:1,
        group_codes:null
      },
      position:{
        lng:0,
        lat:0
      },
      center:{
        lng:0,
        lat:0
      },
      spinShow:false,
      formRules: {
        shop_name: [{ required: true, message:  this._vm.$t('agentmenu.namecannotbenull'), trigger: 'change' }],
      //  client_id:[{required: true, message: '应用ID不能为空', trigger: 'change'}],
        contacts_name: [
          {required: true,message:  this._vm.$t('agentmenu.contactcannotbenull'), trigger: 'change'}
        ],
        area_code: [
          {required: true,type:'array',message: this._vm.$t('agentmenu.areacannotbenull'), trigger: 'change'}
        ],
        address: [
          {required: true,message: this._vm.$t('agentmenu.addresscannotbenull'), trigger: 'change'}
        ],
        after_sale_tel: [
          {required: true,message: this._vm.$t('agentmenu.aftercannotbenull'), trigger: 'change'}
        ],
        contacts_tel: [
          {required: true,message: this._vm.$t('agentmenu.mobileoremailcannotbenull'), trigger: 'change'}
        ],
        login_password: [
          {required: true,message: this._vm.$t('agentmenu.loginpasswordcannotbenull'), trigger: 'change'}
        ],
        pass_priv: [
          {required: true,type:'number',message: this._vm.$t('是否有管理密码权限必须'), trigger: 'change'}
        ],
        params_priv: [
          {required: true,type:'number',message: this._vm.$t('是否有参数设置必须'), trigger: 'change'}
        ],
         group_codes: [
          {required: true,type:'array',message:this._vm.$t('请选择默认权限'), trigger: 'change'}
        ],
        lng: [
          { required: true, type:'number', message: this._vm.$t('agentmenu.mapcannotbenull'), trigger: 'change' }
        ],
      },
      nodeList:[],
      tempData:{},//等待提交的临时数据
    }
  },
  props: {
    _vm: {},
    edit: {
      type:Boolean,
      default:false
    },
    $store: {},
    setData: {},
    parent_code:{},
    parent_name:{}
  },
  components:{

    },
  computed: {
    getAction(){
      let result = '';
      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file
      }
      return result;
    },
    projectCode(){
      return this.$store.state.user.projectCode
    }
  },
  methods: {
    initmap(position,vm) {

      if (position.lng) {
        var map = new AMap.Map("container1", {
          zoom: 12,
          resizeEnable: true,
          center:  [position.lng, position.lat],
        });
     vm.formModel.lng=position.lng
     vm.formModel.lat=position.lat
        window.geocoder = new AMap.Geocoder({
              zoom: 12,
              center:  [position.lng, position.lat],
          });
        marker = new AMap.Marker({
          icon: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
          position: [position.lng, position.lat],
          offset: new AMap.Pixel(-25, -60),
          // 图标所用图片大小
          Size: new AMap.Size(15, 25),
        });
        marker.setMap(map);
      } else {
       var map = new AMap.Map("container1", {
          resizeEnable: true,
     });
      var marker = new AMap.Marker();;
      //新增时
      window.geocoder = new AMap.Geocoder("container1", {
        zoom: 12
     });
}

map.on('click', showInfoClick);

function showInfoClick(e) {
   //alert('新增 您在 [ ' + e.lnglat.getLng() + ',' + e.lnglat.getLat() + ' ] 的位置单击了地图！')
   let lng = e.lnglat.getLng()
   let lat = e.lnglat.getLat()
    vm.formModel.lng=lng
    vm.formModel.lat=lat
    if(marker){
    marker.setMap(null);
    marker = null;
      }

if (!marker) {
marker = new AMap.Marker({
     icon: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
     position: [e.lnglat.getLng(), e.lnglat.getLat()],
     offset: new AMap.Pixel(-25, -60),
     // 图标所用图片大小
     Size: new AMap.Size(25, 34),
   });
}
  marker.setMap(map);
  window.geocoder.getAddress([e.lnglat.getLng(), e.lnglat.getLat()], function(status, result) {
            if (status === 'complete'&&result.regeocode) {
                var address = result.regeocode.formattedAddress;
                console.log(address)
                vm.formModel.address=address
            }else{
			         	console.log(result)
				        console.log(status)
                log.error('根据经纬度查询地址失败')
            }
        });



}
    },
    searchcomplete(e){
         this.$nextTick(() => {
          if (e && e.Br && e.Br[0]) {
            this.center = e.Br[0].point;  //这里获取了检索的位置并跳转
            this.getLatLng(this.center)
            var allOverlay = this.map.getOverlays();
            this.map.removeOverlay(allOverlay[allOverlay.length-1]);
          }

        });
    },
    markersset(e){
    },
    searchMap(value){
      this.keyword = value
      let vm=this
      //alert(this.keyword);
      var marker,map = new AMap.Map("container1", {
        resizeEnable: true
      });
      window.geocoder = new AMap.Geocoder({
          zoom: 10,
      });

      // AMap.service(["AMap.PlaceSearch"], function() {
      //   //构造地点查询类
      //   var placeSearch = new AMap.PlaceSearch({
      //       map: map, // 展现结果的地图实例
      //   });
      //   //关键字查询
      //   placeSearch.search(vm.keyword);

      //});
     geocoder.getLocation(vm.keyword, function(status, result) {
        if (status === 'complete' && result.geocodes.length) {
          var geocode = result.geocodes[0];
          let lo={"lng":geocode.location.lng,"lat":geocode.location.lat}
          vm.initmap(lo,vm);
        //     marker, map = new AMap.Map("container1", {
        //      resizeEnable: true,
        //      center:[geocode.location.lng, geocode.location.lat]
        //   });

        //   //console.log("经纬度",geocode.location.t.lng); // 经纬度信息
        //   // console.log("result",geocode.location.lng);
        //  marker = new AMap.Marker({
        //     icon: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        //     position: [geocode.location.lng, geocode.location.lat],
        //     offset: new AMap.Pixel(-25, -60),
        //     // 图标所用图片大小
        //     Size: new AMap.Size(25, 34),
        //   });
        //   marker.setMap(map);


        }

    });


      map.on('click', showInfoClick);

    function showInfoClick(e) {
      console.log('您在 [ ' + e.lnglat.getLng() + ',' + e.lnglat.getLat() + ' ] 的位置单击了地图！')
      let lng = e.lnglat.getLng()
      let lat = e.lnglat.getLat()
    vm.formModel.lng=lng
    vm.formModel.lat=lat
    if(marker){
    marker.setMap(null);
    marker = null;
      }

    if (!marker) {
      marker = new AMap.Marker({
        icon: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [e.lnglat.getLng(), e.lnglat.getLat()],
        offset: new AMap.Pixel(-25, -60),
        // 图标所用图片大小
        Size: new AMap.Size(25, 34),
      });
    }
      marker.setMap(map);

       window.geocoder.getAddress([e.lnglat.getLng(), e.lnglat.getLat()], function(status, result) {
            if (status === 'complete'&&result.regeocode) {
                var address = result.regeocode.formattedAddress;
                console.log(address)
                vm.formModel.address=address
            }else{
			         	console.log(result)
				        console.log(status)
                log.error('根据经纬度查询地址失败')
            }
       });

    }

      },
    handler({ BMap, map }) {
        //console.log("asdf",this.setData)
        this.zoom=12;
        const _this = this
        if(this.setData){
          _this.$set(_this.center,'lng',this.setData.lng)
          _this.$set(_this.center,'lat',this.setData.lat)
        }else{
          const geolocation = new BMap.Geolocation()
          geolocation.getCurrentPosition(function (r) {
            if(r){
              _this.center = { lng: r.longitude, lat: r.latitude }
              _this.$set(_this.center,'lng',r.longitude)
              _this.$set(_this.center,'lat',r.latitude)
              _this.initLocation = true
            }

          })
        }

        _this.BMap = BMap
        _this.map=map
    },
         /**
   * 地图点击事件
   */
    mapClick({ type, target, point, pixel, overlay }) {

        var allOverlay = this.map.getOverlays();
        for(let i in allOverlay){
          let list=allOverlay[i]
          if(list.formStat){
            this.map.removeOverlay(list);
          }
        }
        console.log({type, target, point, pixel, overlay})
        this.$set(this,'position',point)
        //console.log("这里是position",this.position)
        this.getLocationAddr(this.position)
        this.getLatLng(point)

      },
      /**
   * 根据点位获取地理位置
   */
  getLocationAddr(point){
    let _this=this;
    const gc = new this.BMap.Geocoder()
    gc.getLocation(point, function (rs) {
        console.log(rs)
        if(rs){
          _this.$set(_this.formValidate,'address',rs.address)
        }

      })
  },
    getLatLng(point){
   //   debugger
      //this.$set(this.formValidate,'lat',point.lat+'')
      //this.$set(this.formValidate,'lng',point.lng+'')
      this.$set(this.formModel, 'lat', point.lat + '')
      this.$set(this.formModel,'lng',point.lng+'')
      this.$set(this.formModel,'center',point.lng+','+point.lat)
    },
    onCheckChange(curr,hVal){
      console.log(curr,hVal)
      let data=[]
      for(let i in curr){
        if(curr[i].area_name){
          data.push(curr[i].area_code)
        }
      }
      this.$set(this.formModel,'area_code',data)
      console.log(this.formModel.area_code)
    },
    getAreaData(callback){
      this.areaData.splice(0)
      area_list({
        page:1,
        page_size:1000,
        parent_code:1,
        all: 2,
        type:1
      }).then(res=>{
        if (res.result === 0) {
          //console.log(data)
          let data=res.body.list
          this.checkTree(data)
          this.areaData=data
          if(callback){
            callback(data)
          }
        }
      })
    },
    checkTree(arr){
      for(let i in arr){

        if(arr[i].area_name){
          arr[i].value=arr[i].area_code
          arr[i].label=arr[i].area_name
          arr[i].title=arr[i].area_name
        }else if(arr[i].shop_name){
          arr[i].title=arr[i].shop_name
        }
        if(arr[i].children_shop && arr[i].children_shop.length>0){
          arr[i].children.push(...arr[i].children_shop)
        }
        if(arr[i].children && arr[i].children.length>0){
          this.checkTree(arr[i].children)
        }
      }
    },
    /**
     * 选中的遍历选择
     */
    checkTreeSelect(arr, selectArr) {
      console.log("aa",arr)
      for(let i in arr){
       if (arr[i].area_name) {
          arr[i].value=arr[i].area_code
          arr[i].label=arr[i].area_name
          arr[i].title = arr[i].area_name

          if(arr[i].area_code && selectArr.indexOf(arr[i].area_code)>-1){
            arr[i].checked=true
          }
        }
        // if(arr[i].children_shop && arr[i].children_shop.length>0){
        //   arr[i].children.push(...arr[i].children_shop)
        // }
        if(arr[i].children && arr[i].children.length>0){
          this.checkTreeSelect(arr[i].children,selectArr)
        }
      }
    },
    createTree(data){
      for(let i in data){
        let list=data[i]
        list['value']=list.cate_code
        list['label']=list.cate_name
        if(list.children && list.children.length>0){
          this.createTree(list.children)
        }
      }
    },

    init () {

    },


  },
  mounted() {
 getgrouplist().then((res)=>{
console.log(res.body.list);
this.roleData=res.body.list
// let arr= res.body.list.forEach(item => {
//       if (item.is_default === 1) {
//         item.group_name += ' (默认)';
//       }
//     });
//      this.$set(this,'roleData',arr)
 })
   if(this.edit){
      if(this.setData){
        //debugger
        console.log("aaa",this.setData)
        Object.assign(this.formModel, this.setData)
        this.getAreaData((data) => {
          console.log('area_code',this.setData.area_code)
              this.checkTreeSelect(data,this.setData.area_code)
        })
        console.log("bbb",this.position);

              this.$set(this.position,'lat',this.setData.lat)
              this.$set(this.position,'lng',this.setData.lng)
              this.$set(this.center,'lat',this.setData.lat)
              this.$set(this.center,'lng',this.setData.lng)
      }
    }else{
      this.getAreaData()
      this.$set(this.formModel,'parent_code',this.parent_code)
   }

this.$nextTick(() => {
     let vm = this
     this.initmap(this.position,vm)
})
  },
  created () {

    // this.init()
  }
}
</script>

<style scoped>
 #container1 {
          width: 100%;
          height: 200px;
  }

 .marker {
      position: absolute;
      top: -20px;
      right: -118px;
      color: #fff;
      padding: 4px 10px;
      box-shadow: 1px 1px 1px rgba(10, 10, 10, .2);
      white-space: nowrap;
      font-size: 12px;
      font-family: "";
      background-color: #25A5F7;
      border-radius: 3px;
    }
  .commonForm /deep/ .ivu-form-item-label {
      text-align: left !important;
  }
  .demo-upload-list {
      display: inline-block;
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border: 1px solid transparent;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
      position: relative;
      box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
      margin-right: 4px;
  }

  .demo-upload-list img {
      width: 100%;
      height: 100%;
  }

  .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
      display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .titleCol {
      text-align: center;
  }

  .uploadTip {
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .contentImg{
    width: 500px;
  }
  .contentIcon{
    cursor:pointer
  }
  .layout50, .layout100 {
    margin-bottom: 15px;
  }

  .layout50 {
    width: calc(50% - 12px);
    padding-left: 8px;
    padding-right: 8px;
  }
  .classLayout{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
  }
   .addLayout{
    text-align: left;
    margin-left:8px;
  }
  .uploadInner{
    position: relative;
  }
  .uploadDelIcon{
    position:absolute;
    top:5px;
    right:5px;
    z-index: 1111;
  }
  .bm-view {
    width: 100%;
    height: 300px;
  }
  .mapWrapper{
    position: relative;
  }
  .mapWrapper .inputContent{
    position: absolute;
    top:5px;
    left:0;
    z-index: 55;
    width:180px;
  }
  .addressLabel{
    display: inline-block;
    width: 100%;
    position: relative;
    vertical-align: middle;
    line-height: normal;
  }
  .noLabel{
    margin-top:30px;
  }
  .amap-icon img,.amap-marker-content img {
      width: 25px;
      height: 34px;
 }
</style>
